// extracted by mini-css-extract-plugin
export default {"navigation":"search-navigation_navigation__qrN7q","tabs":"search-navigation_tabs__l3KvA"};